export default __webpack_public_path__ + "static/media/logo-dark.e16a5a11.png";